import { useMemo } from 'react';

import { useClients } from '~/api/clients';
import { useUser } from '~/api/user';

import { useFormWithLinesContext } from './FormLines.context';

export const useSelectedContactLanguage = () => {
  const { data: user } = useUser();
  const { data: clients } = useClients();
  const { watch } = useFormWithLinesContext();

  const selectedContactId = watch('contactId');

  const contactLanguage = useMemo(
    () => clients.flatMap(({ contacts }) => contacts).find((contact) => contact.id === selectedContactId)?.language,
    [clients, selectedContactId],
  );
  const userLanguage = user.lang;

  return contactLanguage ?? userLanguage;
};
